module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reservation-route"
  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
    ref: "logs",
    attrs: {
      "api-key": _vm.mapsAPI,
      "center": _vm.mapCenter,
      "mapTypeControl": true
    }
  }, [(_vm.zones.allowed) ? _c('div', _vm._l((_vm.zones.allowed.poly), function(allowed) {
    return _c('google-map-polygon', {
      attrs: {
        "positions": allowed,
        "color": "green",
        "fillColor": "green"
      }
    })
  }), 1) : _vm._e(), (_vm.zones.forbidden) ? _c('div', _vm._l((_vm.zones.forbidden.poly), function(forbidden) {
    return (_vm.zones.forbidden !== null) ? _c('google-map-polygon', {
      attrs: {
        "positions": forbidden
      }
    }) : _vm._e()
  }), 1) : _vm._e(), (_vm.zones.undesiderable) ? _c('div', _vm._l((_vm.zones.undesiderable.poly), function(undesiderable) {
    return (_vm.zones.undesiderable) ? _c('google-map-polygon', {
      attrs: {
        "positions": undesiderable,
        "color": "yellow",
        "fillColor": "yellow"
      }
    }) : _vm._e()
  }), 1) : _vm._e(), _vm._l((_vm.currentPointStep), function(index) {
    return (_vm.showMarkers) ? _c('GoogleMapMarker', {
      attrs: {
        "label": ("" + index),
        "title": ("" + index),
        "position": _vm.routes[index - 1],
        "clickable": true
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.$date(_vm.routes[index - 1].timestamp).format('DD MMM YYYY HH:mm:ss')))])]) : _vm._e()
  }), _c('GoogleMapPolyline', {
    attrs: {
      "positions": _vm.showRoute
    }
  })], 2)], 1), _c('Slider', {
    attrs: {
      "max": _vm.routes.length
    },
    on: {
      "input": _vm.center
    },
    model: {
      value: (_vm.currentPointStep),
      callback: function($$v) {
        _vm.currentPointStep = $$v
      },
      expression: "currentPointStep"
    }
  }), (_vm.routes.length) ? _c('div', {
    staticClass: "player"
  }, [_c('span', [_vm._v(_vm._s(_vm.$date(_vm.routes[0].timestamp).format('DD MMM YYYY HH:mm:ss')))]), _c('span', [_vm._v(_vm._s(_vm.$date(_vm.routes[_vm.currentPoint].timestamp).format('DD MMM YYYY HH:mm:ss')))]), _c('span', [_vm._v(_vm._s(_vm.$date(_vm.routes[_vm.routes.length - 1].timestamp).format('DD MMM YYYY HH:mm:ss')))])]) : _vm._e(), _c('div', {
    staticClass: "player"
  }, [_c('div', {
    staticClass: "buttons fa fa-2x",
    class: _vm.autoPlayClass,
    on: {
      "click": _vm.togglePlay
    }
  }), _c('div', {
    staticClass: "buttons fa fa-2x fa-map-marker",
    style: ([_vm.showMarkers ? {
      color: 'green'
    } : '']),
    on: {
      "click": function($event) {
        _vm.showMarkers = !_vm.showMarkers
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-657c4d6a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ReservationRoute.vue
// module id = 2536
// module chunks = 1